import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ExtensionPointProvider = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "forge-extension-point-provider" */ './extension-point-provider')
    ),
    LoadingSkeleton: () => null,
});
